export enum PlanMethod {
  // 实数单
  REAL = "1",
  // 排单单
  QUEUE = "2",
}

export const PlanMethodOptions = [
  { label: "实数单", value: PlanMethod.REAL },
  { label: "排单单", value: PlanMethod.QUEUE },
];

/**
 * ERP 账号角色 id（与后端 Kotlin 常量对齐）
 * BOSS_ROLE_ID=4、SHOP_STAFF_ROLE_ID=2、SHOP_REPO_ROLE_ID=3；
 * 店长 SHOP_OWNER_ROLE_ID 若与后端不一致请改此处。
 */
export const BOSS_ROLE_ID = 4;
/** 店长；后端未在文档中写数值时按 2/3/4 已占用推定为 1 */
export const SHOP_OWNER_ROLE_ID = 1;
export const SHOP_STAFF_ROLE_ID = 2;
export const SHOP_REPO_ROLE_ID = 3;

/**
 * 角色枚举（同 {@link BOSS_ROLE_ID} 等，便于沿用既有 RoleEnum.BOSS 写法）
 */
export const RoleEnum = {
  /** 店长 */
  SHOP_OWNER: SHOP_OWNER_ROLE_ID,
  /** 店员 */
  SHOP_STAFF: SHOP_STAFF_ROLE_ID,
  /** 仓管 */
  SHOP_REPO: SHOP_REPO_ROLE_ID,
  /** 老板（主账户） */
  BOSS: BOSS_ROLE_ID,
} as const;

const BOSS_OR_MANAGER_ROLE_NAMES = new Set(["老板", "店长"]);

/** 是否具备打开「选择处理方式」流程的账号角色（老板或店长） */
export function isBossOrShopManagerRole(
  user: { roleId?: number; roleName?: string } | undefined,
): boolean {
  if (!user) return false;
  if (user.roleId === RoleEnum.BOSS || user.roleId === RoleEnum.SHOP_OWNER) {
    return true;
  }
  const name = user.roleName?.trim();
  return Boolean(name && BOSS_OR_MANAGER_ROLE_NAMES.has(name));
}

/**
 * 业务类型
 */
export interface IBusinessType {
  /**
   * 检测报告属性 Id
   */
  inspectionReportPropId: string;
  /**
   * 检测报告属性选项「有」的 Id
   */
  hasInspectionReportId: string;
}

const BusinessMap: Record<string, IBusinessType> = {
  prod: {
    inspectionReportPropId: "207",
    hasInspectionReportId: "26174",
  },
  pre: {
    inspectionReportPropId: "207",
    hasInspectionReportId: "26174",
  },
  outer: {
    inspectionReportPropId: "207",
    hasInspectionReportId: "26174",
  },
  test: {
    inspectionReportPropId: "207",
    hasInspectionReportId: "26174",
  },
  dev: {
    inspectionReportPropId: "207",
    hasInspectionReportId: "26174",
  },
};

/**
 * 认证状态枚举
 */
export const AuthStatus = {
  /**
   * 需要认证
   */
  NEED_AUTH: "1",
  /**
   * 不需要认证
   */
  NO_NEED_AUTH: "0",
} as const;

// 业务数据
export const businessMap = BusinessMap[REACT_APP_ENV || "prod"];
